module.exports = __webpack_public_path__ + "images/stickers/pete-music@2x.df6a7a7b952e8826916f.png";